module.exports = __webpack_public_path__ + "ace536bccebf7b78718737db432119dd.png";